<template>
  <el-dialog
    :title="dialogType === 1 ? '录入编号' : '表具编号'"
    v-model="visible"
    :close-on-click-modal="false"
    :width="dialogType === 1 ? '500px' : '900px'"
    @close="cancel"
  >
    <div class="add" v-if="dialogType === 1">
      <div class="add-item">
        <span class="label">录入方式：</span>
        <el-radio-group v-model="entrymethod">
          <el-radio :label="1">手动录入</el-radio>
          <el-radio :label="2">文件导入</el-radio>
        </el-radio-group>
      </div>
      <div v-if="entrymethod === 1">
        <div
          class="add-item"
          v-for="(item, index) in tableData_All"
          :key="index"
        >
          <span class="label requier">表具编号：</span>
          <el-input v-model="item.keyNumber" placeholder="请输入" />
          <el-icon><CirclePlusFilled @click="addRow" /></el-icon>
          <el-icon class="icon2"
            ><RemoveFilled @click="batchDelete([item.id])" v-if="index !== 0"
          /></el-icon>
        </div>
      </div>
      <div v-else>
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;
          "
        >
          <el-button type="primary" icon="Download" @click="downloadTemplate">
            下载模板
          </el-button>
        </div>
        <el-upload
          ref="upload"
          drag
          action=""
          accept=".xls, .xlsx"
          :auto-upload="true"
          :limit="1"
          v-model:file-list="fileList"
          :before-upload="beforeUpload"
          :on-exceed="handleExceed"
          :http-request="customUpload"
          :on-remove="removeFile"
          :on-success="fileSuccess"
        >
          <!-- :on-change="handleChange" -->
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">拖入文件或 <em>点击上传</em></div>
          <template #tip>
            <div class="el-upload__tip">
              仅支持单个文件上传，文件大小不超过10M，支持格式：xls /xlsx
            </div>
          </template>
        </el-upload>
      </div>
    </div>
    <div class="editOrDetail" v-else>
      <el-form :model="searchData" :inline="true" ref="searchRef">
        <el-form-item label="表具编号：" prop="keyNumber">
          <el-input v-model="searchData.keyNumber" placeholder="请输入" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="Search" @click="getTableData()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            v-if="dialogType === 2"
            type="primary"
            icon="Search"
            @click="addRow"
            >新增一行</el-button
          >
          <el-button
            v-if="dialogType === 2"
            type="primary"
            icon="Search"
            @click="batchDelete(selectedKeyNumbers, true)"
            >批量移除</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        ref="tableRef"
        max-height="400px"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="dialogType === 2"
          type="selection"
          width="55"
          :reserve-selection="true"
        />
        <el-table-column
          v-if="dialogType === 3"
          label="序号"
          type="index"
          width="55"
          fixed
          :index="indexMethod"
        />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #header="{ column }">
              <span
                v-if="item.required && dialogType === 2"
                style="color: #f56c6c"
                >*</span
              >
              {{ column.label }}
            </template>

            <template #default="{ row }">
              <el-input
                v-if="item.prop === 'keyNumber' && dialogType === 2"
                v-model="row.keyNumber"
                placeholder="请输入"
                :maxlength="40"
                v-no-space
              />
              <span v-else>
                {{ row[item.prop] || "-" }}
              </span>
            </template>
          </el-table-column>
        </template>
        <el-table-column
          label="操作"
          width="150"
          fixed="right"
          v-if="dialogType === 2"
        >
          <template #default="{ row }">
            <el-button type="danger" link @click="batchDelete([row.id])"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="handleSelectionComplete()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { ElMessage } from "element-plus";
import { UploadFilled, Download } from "@element-plus/icons-vue";
import { importKeyMaterial, GetTemplate } from "@/api/keyMaterial"; // 假设你有一个上传文件的API
import { postDownload } from "@/utils";

const getId = () => {
  let id = "";
  const characters = "0123456789";
  for (let i = 0; i < 18; i++) {
    id += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return id;
};
const visible = ref(false); // 弹窗控制
const searchRef = ref(null); // 搜索表单ref
const tableRef = ref(null); // 表格的ref
// 搜索条件
const searchData = reactive({
  keyNumber: null,
});
const dialogType = ref(1); // 1新增 2编辑 3查看
const requireNumber = ref(0); // 需求数量 0不做限制
const entrymethod = ref(1); // 需求数量 0不做限制

// 表格数据
const original_row = ref(null); // 原生row引用地址

const tableData = ref([]);
const tableData_All = ref([
  {
    id: getId(),
    materialName: null,
    number: null,
    model: null,
    keyNumber: "",
  },
]);
// 表格列配置
const columns = ref([
  {
    label: "物料名称",
    prop: "materialName",
  },
  {
    label: "物料编号",
    prop: "number",
  },

  {
    label: "规格型号",
    prop: "model",
  },
  {
    label: "表具编号",
    prop: "keyNumber",
    required: true, // 添加必填标记
  },
]);
// 分页数据
const pages = reactive({
  page: 1,
  size: 10,
  total: 0,
});
const handleReset = () => {
  searchRef.value?.resetFields();
  pages.page = 1;
  getTableData();
};
const handleSizeChange = (val) => {
  pages.size = val;
  pages.page = 1;
  getTableData();
};
const handleCurrentChange = (val) => {
  pages.page = val;
  getTableData();
};
const indexMethod = (index) => {
  // 计算连续序号
  return (pages.page - 1) * pages.size + index + 1;
};

// 弹窗打开
// row 要改变的表格项数据(必填):
// 1.新增时只需要传入引用地址即可,完成新增后会自动更新row.keyNumberList
// 2.编辑和查看时,需要传入row.materialName row.number  row.model  row.keyNumberList 作为表格显示

// dialogType(必填): 1新增 2编辑 3查看

// requireNumber(选填) 需要填写的数量,不传不做数量校验
const handleDialogOpen = (data) => {
  tableRef.value?.clearSelection();
  const { row, dialogType: _dialogType, requireNumber: _requireNumber } = data;
  dialogType.value = _dialogType;
  requireNumber.value = _requireNumber || 0;
  original_row.value = row;

  if (dialogType.value !== 1) {
    tableData_All.value = row.keyNumberList.map((ele) => {
      return {
        id: getId(),
        materialName: row.materialName,
        number: row.number,
        model: row.model,
        keyNumber: ele,
      };
    });
    getTableData();
  }
  console.log("tableData_All.value==>", tableData_All.value);

  visible.value = true;
};

// 数据选中事件
const selectedKeyNumbers = ref([]);
const handleSelectionChange = (val) => {
  selectedKeyNumbers.value = val.map((item) => item.id);
  console.log("选中改变===>", selectedKeyNumbers.value);
};
// 删除
// isclearSelection是否清空选中,批量移除后需要清空
const batchDelete = (ids, isclearSelection) => {
  console.log("移除事件===>", ids);
  if (ids.length >= tableData_All.value.length) {
    ElMessage.error("请至少保留一条表具编号数据!");
    return;
  }
  // 从 tableData_All.value 中移除 ids(格式为[1,2,3....])
  tableData_All.value = tableData_All.value.filter(
    (item) => !ids.includes(item.id)
  );
  if (isclearSelection) tableRef.value?.clearSelection();
  //  编辑,删除后,刷新表格(清除移除)
  if (dialogType.value === 2) {
    // 计算最大页码
    const maxPage = Math.ceil(tableData_All.value.length / pages.size) || 1;

    // 如果当前页码大于最大页码，则调整当前页码为最大页码
    if (pages.page > maxPage) {
      pages.page = maxPage;
    }

    // 重新获取表格数据
    getTableData();
  }
};

// 新增一行
const addRow = () => {
  if (dialogType.value === 1) {
    tableData_All.value.push({
      id: getId(),
      materialName: original_row.value?.materialName || null,
      number: original_row.value?.number || null,
      model: original_row.value?.model || null,
      keyNumber: null,
    });
  } else {
    tableData_All.value.unshift({
      id: getId(),
      materialName: original_row.value?.materialName || null,
      number: original_row.value?.number || null,
      model: original_row.value?.model || null,
      keyNumber: null,
    });
    getTableData();
  }
};

// 根据分页和搜索条件  获取数据
const getTableData = () => {
  // 根据搜索条件过滤数据
  let filteredData = tableData_All.value.filter((item) => {
    if (searchData.keyNumber) {
      return item.keyNumber && item.keyNumber.includes(searchData.keyNumber);
    }
    return true;
  });

  // 更新分页总数
  pages.total = filteredData.length;

  // 根据分页参数截取数据
  const start = (pages.page - 1) * pages.size;
  const end = start + pages.size;
  tableData.value = filteredData.slice(start, end);
};

// 取消/初始化
const cancel = () => {
  pages.page = 1;
  pages.size = 10;
  pages.total = 0;
  searchData.keyNumber = null;
  requireNumber.value = 0;
  entrymethod.value = 1;

  tableData_All.value = [
    {
      id: getId(),
      materialName: null,
      number: null,
      model: null,
      keyNumber: "",
    },
  ];
  tableData.value = [];
  original_row.value = {};

  visible.value = false;
};

// 点击确定按钮
const handleSelectionComplete = () => {
  if (!tableData_All.value.length) {
    ElMessage.error("请至少填写一个表具编号!");
    return;
  }
  if (
    tableData_All.value.some(
      (ele) => !ele.keyNumber || ele.keyNumber.trim() === ""
    )
  ) {
    ElMessage.error("请填写所有项的表具编号!");
    return;
  }
  // 检查表具编号是否重复
  const keyNumbers = tableData_All.value.map((item) => item.keyNumber);
  const uniqueKeyNumbers = new Set(keyNumbers);
  if (keyNumbers.length !== uniqueKeyNumbers.size) {
    ElMessage.error("表具编号不能重复!");
    return;
  }
  if (
    requireNumber.value &&
    tableData_All.value.length !== requireNumber.value
  ) {
    ElMessage.error("表具编号数量必须与出库数量一致!");
    return;
  }
  // 修改原始引用地址row 的keyNumberList
  original_row.value.keyNumberList = keyNumbers;
  original_row.value.changeQuantity = keyNumbers.length;

  cancel();
};

// 文件导入相关
const upload = ref(null);
const fileList = ref([]);

// 下载模版
const downloadTemplate = async () => {
  try {
    // 直接使用 axios(封装的request会处理get请求的blob文件,会报错)
    let token = getToken();
    const response = await axios({
      url: "/api/storeroom/keyMaterial/template",
      method: "get",
      responseType: "blob",
      headers: {
        "zh-Token": token,
        Atomtoken: token,
      },
    });

    // 创建下载链接
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = "表具编号模板.xlsx"; // 设置下载的文件名

    // 触发下载
    document.body.appendChild(link);
    link.click();

    // 清理
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    ElMessage.success("模板下载成功");
  } catch (error) {
    console.error("下载模板失败:", error);
    ElMessage.error(error.message || "模板下载失败");
  }
};
// 上传前的校验
const beforeUpload = (file) => {
  // 检查文件大小
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    ElMessage.error("上传文件大小不能超过 10MB!");
    return false;
  }
  return true;
};
// 文件超出限制
const handleExceed = () => {
  ElMessage.error("只允许上传一个文件,更新文件请删除之前文件!");
};

// 自定义上传方法
const customUpload = async (options) => {
  const { file, onProgress, onSuccess, onError } = options;

  try {
    // 创建FormData对象
    const formData = new FormData();
    formData.append("file", file);

    // 调用上传接口
    const res = await importKeyMaterial(formData, {
      onUploadProgress: (progressEvent) => {
        // 计算上传进度
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress({ percent: percentCompleted }, file);
      },
    });
    console.log("自定义上传方法上传导入接口====>", res);

    // 处理返回的数据
    if (res.code === "2000" || res.code === 200) {
      ElMessage.success("上传成功");
      // 在这里处理返回的数据
      console.log("自定义上传方法上传返回的数据:", res.data);

      // 调用成功回调
      onSuccess(res, file);

      // 可以在这里执行其他操作，比如刷新列表等
      // handleRefreshList();
    } else {
      ElMessage.error(res.message || "上传失败");
      onError(new Error(res.message || "上传失败"));
    }
  } catch (error) {
    console.error("上传出错:", error);
    ElMessage.error(error.message || "上传失败");
    onError(error);
  }
};
// 文件选择变化时的处理
const handleChange = (file, fileList) => {
  // 可以在这里做一些文件选择后的处理
  console.log("文件已选择:", file);
};
// 上传成功
const fileSuccess = (res) => {
  console.log("上传成功2===>", res);
  if (res) {
    tableData_All.value = res.data.map((ele) => {
      return {
        id: getId(),
        materialName: original_row.value.materialName || null,
        number: original_row.value.number || null,
        model: original_row.value.model || null,
        keyNumber: ele.number,
      };
    });
  }
};

// 移除文件
const removeFile = () => {
  console.log("移除===>");
  tableData_All.value = [
    {
      id: getId(),
      materialName: null,
      number: null,
      model: null,
      keyNumber: "",
    },
  ];
};

defineExpose({
  handleDialogOpen,
});
</script>

<style lang="less" scoped>
.add {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  .add-item {
    width: 100%;
    display: flex;
    align-items: center;
    margin-block: 10px;
    .label {
      width: 80px;
      text-align: right;
      margin-right: 10px;
      color: #333;
      font-size: 14px;
    }
    .requier {
      position: relative;
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
        position: absolute;
        left: 0px;
        top: 0;
      }
    }

    .el-input {
      width: 300px;
    }

    .el-icon {
      margin-left: 10px;
      cursor: pointer;
      color: #3478f6;
      font-size: 16px;
    }
    .icon2 {
      color: #f56c6c;
    }
  }
}
.editOrDetail {
  width: 100%;
  .el-table {
    &::-webkit-scrollbar {
      width: 4px;
    }
  }
}
</style>
